/**
 * Labstep
 *
 * @module components/Metadata/Action/Create/Modal/Wizard/MetadataActionCreateModalWizardStepFieldName
 * @desc Step 3: Field Name - Customize the field name and inverse field name
 */

import { FieldDefinitionFormLinkTypePreview } from 'labstep-web/components/FieldDefinition/Form/LinkTypePreview';
import type { IValues } from 'labstep-web/core/Form/Reusable/types';
import { EntityRelationType } from 'labstep-web/models/field-definition.model';
import { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import { Form, Input } from 'semantic-ui-react';

interface MetadataActionCreateModalWizardStepFieldNameProps {
  formValues: IValues;
  onFormChange: (values: IValues) => void;
}

export const MetadataActionCreateModalWizardStepFieldName: React.FC<
  MetadataActionCreateModalWizardStepFieldNameProps
> = ({ formValues, onFormChange }) => {
  const isAsymmetric =
    formValues?.entity_relation_type ===
    EntityRelationType.asymmetric;

  return (
    <>
      <Form>
        <Form.Field required>
          <label>Field Name</label>
          <Input
            placeholder="Enter the name of the relation i.e. parent, child, related..."
            value={(formValues.label as string) || ''}
            onChange={(e) => {
              onFormChange({ label: e.target.value });
            }}
          />
        </Form.Field>

        {isAsymmetric && (
          <Form.Field>
            <label>Inverse Field Name</label>
            <Input
              placeholder="Enter the name of inverse relation"
              value={(formValues.inverse_relation as string) || ''}
              onChange={(e) => {
                onFormChange({ inverse_relation: e.target.value });
              }}
            />
          </Form.Field>
        )}
      </Form>

      {/* Preview section */}
      <div style={{ marginTop: '20px' }}>
        <FieldDefinitionFormLinkTypePreview
          entityName={Resource.getHumanReadableEntityName(
            false,
            true,
          )}
          relationType={
            formValues.entity_relation_type as EntityRelationType
          }
          relationName={formValues.label as string}
          backLinkName={
            formValues.entity_relation_type ===
              EntityRelationType.asymmetric &&
            formValues.inverse_relation
              ? (formValues.inverse_relation as string)
              : ''
          }
          categoryNameA={(formValues.current_entity as any)?.name}
          categoryNameB={
            (
              formValues.entity_relation_target_entity_filter_template as any
            )?.name
          }
        />
      </div>
    </>
  );
};
